import chip_2_dollars from './files/chip_2-dollars.svg'
import chip_5_dollars from './files/chip_5-dollars.svg'
import chip_20_dollars from './files/chip_20-dollars.svg'

import table_felt_bg from './files/table_felt_bg.jpg'
import hi_button_bg from './files/hi_button.svg'
import lo_button_bg from './files/lo_button.svg'
import same_button_bg from './files/same_button_bg.svg'
import same_button_bg_hover from './files/same_button_bg-hover.svg'

export const hiloImg = {
  chip_2_dollars,
  chip_5_dollars,
  chip_20_dollars,
  table_felt_bg,
  hi_button_bg,
  lo_button_bg,
  same_button_bg,
  same_button_bg_hover,
}
